import { useEffect, useState } from 'react';
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { VpnKeyOutlined } from '@mui/icons-material';

const PIN_REGEX = /^[0-9]{4}$/;

const AssignPinModal = ({ open, onClose, onAsignar, vendedorNombre, tienePin, loading }) => {
  const [pin, setPin] = useState("");

  useEffect(() => {
    if (open) setPin("");
  }, [open]);

  const handlePinChange = (e) => {
    const soloNumeros = e.target.value.replace(/\D/g, "").slice(0, 4);
    setPin(soloNumeros);
  };

  const handleSubmit = () => {
    if (!PIN_REGEX.test(pin)) return;
    onAsignar(pin);
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h6" sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0062", fontWeight: 600 }}>
            {tienePin ? "Restablecer PIN" : "Asignar PIN"}
          </Typography>
          {tienePin && (
            <Chip
              icon={<VpnKeyOutlined sx={{ fontSize: "14px !important", color: "#2e7d32 !important" }} />}
              label="PIN configurado"
              size="small"
              sx={{
                backgroundColor: "#e8f5e8",
                color: "#2e7d32",
                fontWeight: 500,
                fontSize: "11px"
              }}
            />
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: "#666", fontSize: "14px", mb: 2 }}>
          Definí el PIN con el que <strong>{vendedorNombre || "este miembro"}</strong> va a iniciar sesión en el punto de venta. <br/>Solo hace falta si va a operar una caja.<br/>
          {" "}Este PIN es personal: el usuario va a tener el mismo PIN en todos los eventos.<br/>
          {tienePin
            ? " Ya tiene un PIN asignado — podés cargar uno nuevo para reemplazarlo."
            : ""}
        </Typography>
        <TextField
          sx={{
            fontFamily: "Bricolage Grotesque",
            '& label.Mui-focused': {
              color: '#5656FF',
              fontFamily: "Bricolage Grotesque"
            },
            '& .MuiOutlinedInput-root': {
              height: "40px",
              '& fieldset': {
                borderColor: '#B2BAC2',
              },
              '&:hover fieldset': {
                borderColor: '#5656ff',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#5656ff',
              },
            }
          }}
          value={pin}
          onChange={handlePinChange}
          placeholder="Ej: 1234"
          inputProps={{ inputMode: "numeric", maxLength: 4 }}
          fullWidth
          margin="none"
          autoFocus
        />
        <Typography sx={{ color: "#999", fontSize: "12px", mt: 0.5 }}>
          Numérico, 4 dígitos.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          sx={{
            border: "1px solid #ccc",
            color: "#666",
            '&:hover': {
              backgroundColor: "#f5f5f5"
            }
          }}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading || !PIN_REGEX.test(pin)}
          sx={{
            backgroundColor: "#5656FF",
            '&:hover': {
              backgroundColor: "#4545dd"
            }
          }}
        >
          {loading ? "Guardando..." : (tienePin ? "Restablecer PIN" : "Guardar PIN")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignPinModal;
